import React, { useState } from "react";
import Modal from "react-modal";
import "./ProfessorCoursesModal.css";

function ProfessorCoursesModal({ professor, courses, onClose }) {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (courseId) => {
    setExpanded((prev) => ({ ...prev, [courseId]: !prev[courseId] }));
  };

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      className="professor-courses-modal"
      overlayClassName="professor-courses-modal-overlay"
      ariaHideApp={false}
    >
      <div className="modal-header">
        <h2>Turmas de {professor?.name}</h2>
        <button className="close-btn" onClick={onClose}>&times;</button>
      </div>
      <div className="courses-tree">
        {courses && courses.length > 0 ? (
          courses.map((course) => (
            <div key={course.id} className="course-item">
              <div className="course-header">
                <button
                  className="expand-btn"
                  onClick={() => toggleExpand(course.id)}
                  aria-label={expanded[course.id] ? "Minimizar" : "Expandir"}
                >
                  {expanded[course.id] ? "-" : "+"}
                </button>
                <span className="course-name">{course.name}</span>
                <span className="students-count">
                  ({course.students ? course.students.length : 0} alunos)
                </span>
              </div>
              {expanded[course.id] && (
                <div className="students-list-minimal">
                  {course.students && course.students.length > 0 ? (
                    course.students.map((student, idx) => (
                      <span key={student.id} className="student-pill">
                        {student.first_name} {student.last_name}{idx < course.students.length - 1 ? ', ' : ''}
                      </span>
                    ))
                  ) : (
                    <span className="no-students">Nenhum aluno cadastrado.</span>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <div>Nenhuma turma encontrada para este professor.</div>
        )}
      </div>
    </Modal>
  );
}

export default ProfessorCoursesModal;
